angular.module('jv.dashboard.controller', [])
    .controller('DashboardController', ['$scope', '$timeout', 'jvDashboardConfig', 'jvDashboardFactory', '$rootScope',
        function($scope, $timeout, $jvDashboardConfig, jvDashboardFactory, $rootScope) {
            var _dashboard = _dashboardObject.dashboard;
            //copy title and dashboard Id into config onject
            $jvDashboardConfig.userDashboardTitle = angular.copy(_dashboard.userDashboardTitle);
            $jvDashboardConfig.dashboardId = angular.copy(_dashboard.dashboardId);
            $jvDashboardConfig.defaultDashboard = angular.copy(_dashboard.default);
            $jvDashboardConfig.dashboardKind = _dashboard.kind;
            delete _dashboard.default;
            var _dashboardConfig = angular.copy($jvDashboardConfig);

            var _min = 0;
            var _max = 0;
            var columnBoundaries = [];

            var columnWidth = _dashboard.layout.columnWidth;

            var findMinAndMaxSize = function(columnWidths) {
                angular.forEach(columnWidths, (function(size, column) {
                    //Implementing only for equal sized columns. Will fix for different sized later.
                    columnBoundaries.push(size * column);

                    if (_min === 0 || size < _min) {
                        _min = size;
                    }
                    if (_max === 0 || size > _max) {
                        _max = size;
                    }
                }));
            };

            //This has to be done only because admin_decorator adds the flag by default. 
            $scope.flags.loading = false;
            $scope.dashboardConfig = {};
            $scope.dashboardConfig.widgets = [];

            //Transform the widets in a format that gridster accepts
            _dashboardConfig.widgets = angular.copy(jvDashboardFactory.transformWidgetsToGridsterObject(_dashboard.userWidgets));
            jvDashboardFactory.resolveWidgetTitle(_dashboardConfig.widgets);
            _dashboardConfig.columns = _dashboard.layout.gridColumns;
            _dashboardConfig.minColumns = _dashboard.layout.numberOfColumns;
            findMinAndMaxSize(_dashboard.layout.columnWidth);
            _dashboardConfig.minSizeX = _min;
            _dashboardConfig.maxSizeX = _max;


            _dashboardConfig.movable.canMove = function(event, $element, widget) {
                if ($.inArray(widget.col, columnBoundaries) !== -1) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.dashboardConfig = _dashboardConfig;

            //Set Widget Instance Map
            jvDashboardFactory.setWidgetInstanceMap();

            //Set current dashboardConfig
            jvDashboardFactory.setDashboardConfig($scope.dashboardConfig);

            //Set dashboard object
            jvDashboardFactory.setUserDashboard(_dashboard);

            //Listen for changes to dashboard config
            $rootScope.$on('DASHBOARD_CONFIG_UPDATED', function() {
                $scope.dashboardConfig = angular.copy(jvDashboardFactory.getDashboardConfig());
            });

        }
    ]);
